import { render, staticRenderFns } from "./MultiselectCustom.vue?vue&type=template&id=66edcfd1&"
import script from "./MultiselectCustom.vue?vue&type=script&lang=js&"
export * from "./MultiselectCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports